<script setup lang="ts">
import { ref, watch } from "vue";
const cron = defineModel<string>({ required: true });
const timezone = defineModel<string>("timezone", { required: true });
defineProps<{ disabled?: boolean }>();
const parts = cron.value.split(" ");
const frequency = ref(
    parts[1] === "*" ? "hourly" : parts[4] !== "*" ? "weekly" : "daily",
  ),
  time = ref(
    parts[1] === "*"
      ? "09:00"
      : `${parts[1]!.padStart(2, "0")}:${parts[0]!.padStart(2, "0")}`,
  ),
  weekday = ref(parts[4] === "*" ? "1" : parts[4]);
const days = [
  "Søndag",
  "Mandag",
  "Tirsdag",
  "Onsdag",
  "Torsdag",
  "Fredag",
  "Lørdag",
];
watch([frequency, time, weekday], () => {
  const [h, m] = time.value.split(":").map(Number);
  if (!Number.isInteger(h) || !Number.isInteger(m)) return;
  cron.value =
    frequency.value === "hourly"
      ? "0 * * * *"
      : `${m} ${h} * * ${frequency.value === "weekly" ? weekday.value : "*"}`;
});
</script>
<template>
  <div class="form-grid">
    <label
      >Hvor ofte?<select v-model="frequency" :disabled="disabled">
        <option value="daily">Hver dag</option>
        <option value="weekly">Hver uge</option>
        <option value="hourly">Hver time</option>
      </select></label
    >
    <label v-if="frequency === 'weekly'"
      >Ugedag<select v-model="weekday" :disabled="disabled">
        <option v-for="(day, i) in days" :key="day" :value="String(i)">
          {{ day }}
        </option>
      </select></label
    >
    <label v-if="frequency !== 'hourly'"
      >Klokken<input v-model="time" type="time" required :disabled="disabled"
    /></label>
    <label
      >Tidszone<select v-model="timezone" :disabled="disabled">
        <option value="Europe/Copenhagen">Danmark</option>
        <option value="UTC">UTC</option>
        <option
          v-if="!['Europe/Copenhagen', 'UTC'].includes(timezone)"
          :value="timezone"
        >
          {{ timezone }}
        </option>
      </select></label
    >
  </div>
</template>
